module.exports = "https://cdn.realtymogul.com/static/media/icon_cancel.24a192f6.svg";